import { Stack, CircularProgress } from "@mui/material";
import React from "react";
import { colors } from "../theme";

const Progress: React.FC<{ color?: string; height?: string | number }> = ({
  color,
  height = "60vh",
}) => {
  return (
    <Stack
      justifyContent={"center"}
      alignItems={"center"}
      direction="row"
      gap={1}
      height={height}
      margin={"auto auto"}
    >
      <CircularProgress sx={{ color: color ?? colors.stone[500] }} />
    </Stack>
  );
};

export default Progress;
